import React, { useContext, useEffect, useState } from 'react';
import { Box, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';
import { useStyles } from './styles';
import { ResponsiveDialog } from '../../../components';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import { LocaleContext } from '../../../ts/routing/LangRouter';
import axios from 'axios';

axios.defaults.withCredentials = true;

const Confirmation = ({ sendForm, open, setOpen }) => {
    const { t } = useTranslation();
    const classes = useStyles();
    const { locale } = useContext(LocaleContext);
    const [lang, setLang] = useState(locale);
    const [services, setServices] = useState([]);
    const [totalPrice, setTotalPrice] = useState(0);
    const [currency, setCurrency] = useState('');
    const [error, setError] = useState('');

    const handleClose = () => {
        setOpen(false);
    };

    useEffect(() => {
        setLang(locale);
    }, [locale]);

    useEffect(() => {
        const fetchInformation = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_KEY}/arscustom/public/appointment/get-information`);
                const data = response.data;
                setServices(data.services || []);
                setTotalPrice(data.totalPrice || 0);
                setCurrency(data.currency || '');
                setError('');
            } catch (error) {
                setError(error.response?.data?.error || 'Failed to fetch information');
                console.error('Failed to fetch information', error);
            }
        };
        fetchInformation();
    }, []);

    const tintGlassService = services.find((service) => !service.additional);
    const additionalServices = services.filter((service) => service.additional);

    return (
        <Box className={classes.container}>
            <Box className={classes.padding}>
                <TableContainer component={Paper} sx={{ boxShadow: 'none', background: '#FCFCFC' }}>
                    <Table>
                        <TableHead>
                            <TableRow>
                                <TableCell className={classes.bold_title}>{t('appointment.service')}</TableCell>
                                <TableCell className={classes.bold_title} align="right">{t('appointment.price')}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {tintGlassService && (
                                <TableRow>
                                    <TableCell>
                    <span className={classes.left}>
                      {lang === 'en' ? tintGlassService.serviceNameEn : tintGlassService.serviceNameFr}
                    </span>
                                    </TableCell>
                                    <TableCell align="right">
                                        {tintGlassService.discountPrice} {tintGlassService.currency}
                                    </TableCell>
                                </TableRow>
                            )}
                            {additionalServices.length > 0 && (
                                <>
                                    <TableRow>
                                        <TableCell colSpan={2} className={classes.bold_title}>
                                            {t('appointment.additional_service')}
                                        </TableCell>
                                    </TableRow>
                                    {additionalServices.map((service) => (
                                        <TableRow key={service.id}>
                                            <TableCell>
                        <span className={classes.additionalServices}>
                          {lang === 'en' ? service.serviceNameEn : service.serviceNameFr}
                        </span>
                                            </TableCell>
                                            <TableCell align="right">
                                                {service.discountPrice} {service.currency}
                                            </TableCell>
                                        </TableRow>
                                    ))}
                                </>
                            )}
                            <TableRow>
                                <TableCell className={classes.bold_title}>{t('appointment.total')}</TableCell>
                                <TableCell align="right" className={classes.bold_title}>
                                    {totalPrice} {currency}
                                </TableCell>
                            </TableRow>
                        </TableBody>
                    </Table>
                </TableContainer>
                {error && <Box className={classes.error} sx={{ mt: 2 }}>{error}</Box>}
            </Box>
            <Box className={classes.button_box}>
                <button onClick={sendForm} className={classes.btn}>
                    {t('common.confirm')}
                </button>
            </Box>
            {open && (
                <ResponsiveDialog
                    label={t('dialog.title')}
                    onClose={handleClose}
                    open={open}
                    content={t(
                        'Your appointment is confirmed! A confirmation e-mail has been sent to your email address.',
                    )}
                />
            )}
        </Box>
    );
};

Confirmation.propTypes = {
    email: PropTypes.string,
    sendForm: PropTypes.func,
    open: PropTypes.bool,
    setOpen: PropTypes.func,
};

export default Confirmation;